import { ChargemasterGenerator } from './chargemaster.generator';
import { ClaimGenerator } from './claim.generator';
import { DocumentGenerator } from './document.generator';
import { EligibilityGenerator } from './eligibility.generator';
import { GuarantorGenerator } from './guarantor.generator';
import { MessageGenerator } from './message.generator';
import { MetricsGenerator } from './metrics.generator';
import { PaymentGenerator } from './payment.generator';
import { RootStore } from './root.store';
import { SettingsGenerator } from './settings.generator';
import { TransactionGenerator } from './transaction.generator';
import {PatientGenerator} from "./patient.generator";
import {OverpaymentGenerator} from "./overpayment.generator";

export class RootGenerator {
    public chargemasterGenerator: ChargemasterGenerator;
    public claimGenerator: ClaimGenerator;
    public guarantorGenerator: GuarantorGenerator;
    public paymentGenerator: PaymentGenerator;
    public overpaymentGenerator: OverpaymentGenerator;
    public documentGenerator: DocumentGenerator;
    public eligibilityGenerator: EligibilityGenerator;
    public messageGenerator: MessageGenerator;
    public metricsGenerator: MetricsGenerator;
    public settingsGenerator: SettingsGenerator;
    public transactionGenerator: TransactionGenerator;
    public patientGenerator: PatientGenerator;

    constructor(rootStore: RootStore) {
        this.claimGenerator = new ClaimGenerator();
        this.guarantorGenerator = new GuarantorGenerator();
        this.paymentGenerator = new PaymentGenerator(this.claimGenerator);
        this.documentGenerator = new DocumentGenerator(this.claimGenerator);
        this.eligibilityGenerator = new EligibilityGenerator(this.claimGenerator);
        this.messageGenerator = new MessageGenerator(this.claimGenerator, rootStore);
        this.metricsGenerator = new MetricsGenerator();
        this.chargemasterGenerator = new ChargemasterGenerator(this.claimGenerator);
        this.transactionGenerator = new TransactionGenerator();
        this.settingsGenerator = new SettingsGenerator(rootStore);
        this.patientGenerator = new PatientGenerator();
        this.overpaymentGenerator = new OverpaymentGenerator(this.patientGenerator);
    }
}
